<template>

  <div class="edit-view-button">

    <el-input
      :placeholder="placeholder"
      v-model="localValue"
      ref="editViewButton"
      @blur="disableInput"
      :disabled="inputDisabled"
      @keyup.enter.native="callSubmitIfInputIsEnabled(); disableInput();"
    >
      <el-button
        class="action-button"
        @mousedown.native.stop.prevent
        @click.native="toggleInput();"
        ref="rightSideButton"
        slot="append" :icon="inputDisabled ? 'el-icon-edit' : ''"
      >
        {{ inputDisabled ? '' : $t('common.ok') }}
      </el-button>
    </el-input>

  </div>

</template>

<script>

export default {
  props: ['value', 'placeholder', 'isValid'],
  watch: {
    localValue() {
      this.$emit('input', this.localValue);
    },
    value() {
      this.localValue = this.value;
    },
  },
  methods: {
    disableInput() {
      if (this.isValid) {
        this.inputDisabled = true;
        this.blurInput();
      } else {
        this.focusInput();
      }
    },
    enableInput() {
      this.inputDisabled = false;
    },
    toggleInput() {
      if (this.isValid) {
        this.callSubmitIfInputIsEnabled();
        this.inputDisabled = !this.inputDisabled;
      }
      this.focusInput();
    },
    callSubmitIfInputIsEnabled() {
      if (!this.inputDisabled) {
        this.$emit('submit');
      }
    },
    focusInput() {
      if (!this.inputDisabled) {
        this.$nextTick(() => this.$refs.editViewButton.$refs.input.focus());
      } else {
        this.blurInput();
      }
    },
    blurInput() {
      this.$nextTick(() => this.$refs.editViewButton.$refs.input.blur());
    },
  },
  data() {
    return {
      inputDisabled: true,
      localValue: '',
    };
  },
  created() {
    this.localValue = this.value;
  },
};
</script>

<style lang="scss">

  .edit-view-button {
    padding-top: 7px;

    @media screen and (max-width: 759px) {
      text-align: center;
    }

    .el-input {
      border-spacing: 0;
      max-width: 300px;

      .el-button {
        width: 55px;
        height: 38px;
        padding: 0;

      }

    }

    .el-input.is-disabled input {
      background-color: white;
      color: #000;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/common/EditViewButton.vue